import cloneDeep from 'lodash.clonedeep'
export default cloneDeep



// WEBPACK FOOTER //
// ./src/third/CloneDeep.js